export default (settings) => {
  const publicHostUrl = `https://${settings.publicHost}`;
  const defaultLogoUrl = `${publicHostUrl}/logo-default.png`;

  return {
    context: 'https://schema.org/',
    publicHostUrl,
    logo: {
      '@type': 'ImageObject',
      '@id': settings.metaFields.logoGuid?.url || defaultLogoUrl,
      url: settings.metaFields.logoGuid?.url || defaultLogoUrl,
      width: settings.metaFields.logoGuid?.attributes?.width || '150',
      height: settings.metaFields.logoGuid?.attributes?.height || '130',
    },
    name: settings.metaFields.metaTitle,
  };
};
